import { UrlMapFn } from '@ks/weblogger/dist/types/config/types';
import { weblogger } from '@kmi/react';

class DMPLogger {
    public weblog: typeof weblogger = null;

    private productName: string = 'wanxiang_dmp';

    private pvUrlMap: UrlMapFn;

    constructor(pvUrlMap?: UrlMapFn) {
        if (pvUrlMap) {
            this.pvUrlMap = pvUrlMap;
        }
        this.weblog = this.setWebLoggerClient();
    }

    private setWebLoggerClient() {
        return weblogger;
    }

    public pageView(page: string, params: {} = {}): void {
        // 触发 enter 事件，通常只需要在 enter 时设置 page 和 params，其他 PV 事件会自动附带 enter 时的设置
        this.weblog.sendImmediately('PV', {
            type: 'enter',
            page: page, // 设置当前进入页面的页面标识（在埋点平台注册，在 App 分析查看）
            params: {
                ...params,
            },
        });
    }

    public userClick(action: string, params: {} = {}): void {
        this.weblog.sendImmediately('CLICK', {
            action: action,
            params: {
                ...params,
            },
            type: 'USER_OPERATION',
        });
    }
}

export default DMPLogger;
